const POLICE_CODES = {
  nationalPolice: 'POL', // Disabled for Spain
  nat: 'NAT', // Disabled for Spain
  ertzaintza: 'ERT',
  mossos: 'MOS',
  isp: 'ISP',
  sef: 'SEF',
  sef2: 'SEF2',
  uhh: 'UHH', // Disabled police
  uhh2: 'UHH2',
  ubyPort: 'CUP',
  ubyPort2: 'CUP2',
  thai: 'THAI',
  feratel: 'FER',
  feratelGermany: 'FERG',
  capcorn: 'CAP', // Only for rendering in UI. It's Feratel. Take a look at getPreloadedPoliceType if you're going to remove it
  sloveniaAgency: 'AJP',
  stadtZurich: 'CHE',
  germanyAVS: 'AVS',
  switzerlandAVS: 'AVSS',
  fake: 'FAKE',
  cev: 'CEV',
  hospedajes: 'HOS',
};

export {POLICE_CODES};
